module.exports = __webpack_public_path__ + "img/report2.280c837.png";